import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7becc378"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mobile-footer" }
const _hoisted_2 = { class: "mobile-footer__inner" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "mobile-footer__title" }, "لینک های کاربردی", -1))
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-6 mb-5 pb-3 offset-1" }
const _hoisted_9 = { class: "col-5" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-12 mb-5 pb-2" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mobile-footer__copyright" }, " تمامی حقوق این سرویس متعلق به مجموعه پي سرا است ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_telephone = _resolveComponent("telephone")!
  const _component_footer_social = _resolveComponent("footer-social")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_router_link, {
                  class: "mobile-footer__link",
                  to: { name: 'Home' }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("خانه")
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  class: "mobile-footer__link",
                  to: { name: 'Page', query: { id: 'rules' } }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("شرایط و قوانین")
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  class: "mobile-footer__link",
                  to: { name: 'FAQ' }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("سوالات متداول")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_router_link, {
                  class: "mobile-footer__link",
                  to: { name: 'Page', query: { id: 'aboutus' } }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("درباره ما")
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  class: "mobile-footer__link",
                  to: { name: 'Contact' }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("تماس با ما")
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_telephone)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_footer_social),
    _hoisted_12
  ]))
}